import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { SuiContainer } from '@splashthat/sui';

import RichTextLabelControl from './components/RichTextLabelControl';
import RequiredControl from './components/RequiredControl';
import ReservedNodeIndication from './components/ReservedNodeIndication';
import PlaceholderTextControl from './components/PlaceholderTextControl';
import SectionSeparator from './components/SectionSeparator';
import EditViewSectionContainer from './EditViewSectionContainer';
import { getEditFormNodeId, getEditFormNode } from '../../selectors';
import getReservedInputNameLabel from '../../utils/getReservedInputNameLabel';

// @TODO: update this, should say "... in the First Name ..." instead of "... in the Guest First Name ..."
const getTooltipContent = (label) => `You may modify the label of this question.
RSVP answers will appear in the "${label}" column of the guest list`;

/**
 * Component for extra guest first name, last name and email questions.
 */
const EditQuestionAdditionalGuestInfoField = ({ formNodeId, name }) => (
    <React.Fragment>
        <RequiredControl />
        <EditViewSectionContainer>
            <SuiContainer variation="flex-group">
                <RichTextLabelControl formNodeId={formNodeId} />
            </SuiContainer>

            <SectionSeparator />

            <SuiContainer variation="flex-group">
                <PlaceholderTextControl formNodeId={formNodeId} />
            </SuiContainer>
            <ReservedNodeIndication
                label={getReservedInputNameLabel(name)}
                tooltip={getTooltipContent(getReservedInputNameLabel(name))}
            />
        </EditViewSectionContainer>
    </React.Fragment>
);

EditQuestionAdditionalGuestInfoField.propTypes = {
    formNodeId: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => {
    const node = getEditFormNode(state);
    const formNodeId = getEditFormNodeId(state);

    return {
        formNodeId,
        name: node.name,
    };
};

export default connect(mapStateToProps)(EditQuestionAdditionalGuestInfoField);
